import React from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, TrendingUp, Shield, ThumbsUp, Award, Building, Users, CreditCard, CheckCircle } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { VendorInterestForm } from '../components/vendor/VendorInterestForm';
export function BecomeVendor() {
  const vendorBenefits = [{
    icon: <BadgeCheck className="h-6 w-6 text-primary" data-id="element-688" />,
    title: 'Certification & Training',
    description: 'Gain credibility with our recognized certification program.'
  }, {
    icon: <TrendingUp className="h-6 w-6 text-primary" data-id="element-689" />,
    title: 'Increased Business',
    description: 'Access a larger customer base through our marketplace.'
  }, {
    icon: <Shield className="h-6 w-6 text-primary" data-id="element-690" />,
    title: 'Standardized Processes',
    description: 'Follow proven methodologies for consistent quality.'
  }, {
    icon: <Users className="h-6 w-6 text-primary" data-id="element-691" />,
    title: 'Customer Management',
    description: 'Easy-to-use tools to manage customer relationships.'
  }, {
    icon: <CreditCard className="h-6 w-6 text-primary" data-id="element-692" />,
    title: 'Secure Payments',
    description: 'Get paid faster with our secure payment system.'
  }, {
    icon: <Award className="h-6 w-6 text-primary" data-id="element-693" />,
    title: 'Professional Growth',
    description: 'Ongoing training and development opportunities.'
  }];
  const steps = [{
    number: '01',
    title: 'Express Interest',
    description: 'Fill out our interest form with your business details to start the process.'
  }, {
    number: '02',
    title: 'Vendor Assessment',
    description: 'Our team will review your application and contact you for verification.'
  }, {
    number: '03',
    title: 'Complete Certification',
    description: 'Attend our training program and receive certification in your service area.'
  }, {
    number: '04',
    title: 'Start Receiving Orders',
    description: 'Once approved, begin accepting service requests and grow your business with Smart Homebox.'
  }];
  const testimonials = [{
    quote: 'Joining Smart Homebox has increased my painting business revenue by 40% in just three months. The certification program also improved our service quality.',
    name: 'Ahmad Rizal',
    company: 'AR Painting Services'
  }, {
    quote: 'The platform handles all the marketing and customer acquisition, allowing me to focus on delivering quality waterproofing services.',
    name: 'Lim Wei Ching',
    company: 'WaterGuard Solutions'
  }, {
    quote: 'As a small repair business, Smart Homebox has given us the credibility and reach we needed to compete with larger companies.',
    name: 'Rajesh Kumar',
    company: 'Fix-It-Right Repairs'
  }];
  return <div className="min-h-screen bg-background" data-id="element-694">
      <Navbar data-id="element-695" />
      <main data-id="element-696">
        {/* Hero Section */}
        <section className="relative bg-white overflow-hidden py-16 sm:py-24 lg:py-32" data-id="element-697">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-698">
            <div className="max-w-3xl mx-auto text-center" data-id="element-699">
              <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl md:text-6xl" data-id="element-700">
                <span className="block" data-id="element-701">Grow Your Business</span>
                <span className="block text-primary mt-2" data-id="element-702">
                  With Smart Homebox
                </span>
              </h1>
              <p className="mt-6 text-xl text-gray-500 max-w-2xl mx-auto" data-id="element-703">
                Join our network of certified home service vendors and connect
                with customers looking for quality painting and waterproofing
                services.
              </p>
              <div className="mt-10" data-id="element-704">
                <a href="#interest-form" className="px-8 py-3 rounded-md bg-primary text-white text-lg font-medium hover:bg-primary/90 transition-colors" data-id="element-705">
                  Express Interest
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Benefits Section */}
        <section className="py-16 bg-gray-50" data-id="element-706">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-707">
            <div className="text-center" data-id="element-708">
              <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-709">
                Vendor Benefits
              </h2>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-710">
                Why service providers choose Smart Homebox
              </p>
            </div>
            <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-711">
              {vendorBenefits.map((benefit, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-712">
                  <div className="flex items-start" data-id="element-713">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center mr-4" data-id="element-714">
                      {benefit.icon}
                    </div>
                    <div data-id="element-715">
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-716">
                        {benefit.title}
                      </h3>
                      <p className="mt-2 text-gray-600" data-id="element-717">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* How to Join Section */}
        <section className="py-16 bg-white" data-id="element-718">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-719">
            <div className="text-center" data-id="element-720">
              <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-721">
                How to Join
              </h2>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-722">
                Four steps to become a Smart Homebox vendor
              </p>
            </div>
            <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-723">
              {steps.map((step, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-724">
                  <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mb-4" data-id="element-725">
                    <span className="text-xl font-bold text-primary" data-id="element-726">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900" data-id="element-727">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-gray-600" data-id="element-728">{step.description}</p>
                </div>)}
            </div>
          </div>
        </section>
        {/* Testimonials Section */}
        <section className="py-16 bg-gray-50" data-id="element-729">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-730">
            <div className="text-center" data-id="element-731">
              <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-732">
                Vendor Success Stories
              </h2>
              <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-733">
                Hear from vendors who have grown their business with Smart
                Homebox
              </p>
            </div>
            <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-734">
              {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-735">
                  <div className="h-10 w-10 text-primary mb-4" data-id="element-736">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" data-id="element-737">
                      <path d="M11.9992 2C6.47715 2 2.00002 6.47715 2.00002 12C2.00002 17.5228 6.47715 22 11.9992 22C17.5213 22 21.9992 17.5228 21.9992 12C21.9992 6.47715 17.5213 2 11.9992 2ZM7.50002 9.75C7.50002 8.50736 8.50738 7.5 9.75002 7.5C10.9927 7.5 12 8.50736 12 9.75C12 10.9926 10.9927 12 9.75002 12C9.52066 12 9.30131 11.9587 9.0979 11.8839C9.81431 13.2243 11.222 14.1115 12.8457 14.1115V15.75C10.1458 15.75 7.96233 13.3928 7.96233 10.5C7.96233 10.2344 7.9839 9.97439 8.0243 9.72131C7.69967 9.79132 7.50002 9.95953 7.50002 9.75ZM13.5 9.75C13.5 8.50736 14.5074 7.5 15.75 7.5C16.9926 7.5 18 8.50736 18 9.75C18 10.9926 16.9926 12 15.75 12C15.5207 12 15.3013 11.9587 15.0979 11.8839C15.8143 13.2243 17.222 14.1115 18.8457 14.1115V15.75C16.1458 15.75 13.9623 13.3928 13.9623 10.5C13.9623 10.2344 13.9839 9.97439 14.0243 9.72131C13.6997 9.79132 13.5 9.95953 13.5 9.75Z" data-id="element-738" />
                    </svg>
                  </div>
                  <p className="italic text-gray-600 mb-4" data-id="element-739">
                    {testimonial.quote}
                  </p>
                  <div data-id="element-740">
                    <p className="font-medium text-gray-900" data-id="element-741">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-742">
                      {testimonial.company}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Interest Form Section */}
        <section id="interest-form" className="py-16 bg-white" data-id="element-743">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-744">
            <div className="max-w-2xl mx-auto" data-id="element-745">
              <div className="text-center mb-10" data-id="element-746">
                <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-747">
                  Express Your Interest
                </h2>
                <p className="mt-4 text-lg text-gray-600" data-id="element-748">
                  Fill out the form below to start the process of becoming a
                  Smart Homebox vendor. Our team will contact you within 2-3
                  business days.
                </p>
              </div>
              <VendorInterestForm data-id="element-749" />
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-750" />
    </div>;
}